import React, { useEffect, useState } from 'react';
import { Card, Button } from 'antd';
import BaseItemInput from '../../../components/input/base_item_input';
import ExerciseCategoryPopover from './exercise_category_popover';

/*
restUrl :{
	create:'',
	read:'',
	update:'',
	delete:''
}

*/

const ItemCategory = (props) => {
  const data = props.data;
  const index = props.index;
  const OnCellClick = props.OnCellClick;
  const selectedId = props.selectedId;
  const setChildState = props.setChildState;
  const updateItem = props.updateItem;
  const deleteItem = props.deleteItem;

  const styles = {
    container: {
      display: 'flex',
      width: '100%',
      height: '3.5rem',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',

      fontFamily: 'Public Sans',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '1.3rem',
      lineHeight: '2.1rem',

      //
      padding: '7px 10px',
      background: '#FFFFFF',
      border: '0.5px solid #7367F0',
      boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
      borderRadius: '4px',

      marginTop: index === 0 ? 20 : 10,
    },
  };
  return (
    <div
      // type="primary"
      style={{ ...styles.container }}
    >
      <Button
        // type="primary"
        style={{
          display: 'flex',
          width: '90%',
          justifyContetn: 'flex-start',
          color: selectedId == data.id ? 'red' : '#4B465C',
        }}
        type="text"
        onClick={(e) => {
          return OnCellClick({ id: data.id, name: data.name });
        }}
      >
        {data?.name}
      </Button>
      {/* <div>{data?.eng_name}</div> */}
      <ExerciseCategoryPopover
        type="text"
        style={{
          display: 'flex',
          width: '3rem',
          flexDirection: 'column',
          justifyContetn: 'center',
          alignItems: 'center',
        }}
        uuid={data.id}
        name={data.name}
        setChildState={setChildState}
        updateItem={updateItem}
        deleteItem={deleteItem}
        component={
          <img
            width={22}
            height={22}
            src={require('../../../assets/images/ico_more.png')}
          />
        }
      />
    </div>
  );
};

const ExerciseCategory = (props) => {
  const {
    title,
    restUrl,
    parentId,
    categories,
    selectedId,
    OnCellClick,
    addItem,
    initData,
    updateItem,
    deleteItem,
    ...res
  } = props;

  const [state, setState] = useState({
    loading: false,
    // data: categories || [],
    value: null,
    reload: new Date(),
  });

  useEffect(() => {
    if (String(parentId).length) {
      initData();

      setTimeout(() => {
        setState((prev) => {
          return {
            ...prev,
            loading: false,
          };
        });
      }, 3000);
    }
  }, [parentId, state.reload]);

  const styles = {
    container: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      alignItems: 'flex-start',
      // justifyContent: 'flex-start',
      padding: 0,
      margin: 0,

      fontFamily: 'Public Sans',
      fontStyle: 'normal',
    },
    body: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      alignItems: 'flex-start',
      height: '67vh',
      overflow: 'auto',
    },
  };

  // useEffect(() => {
  //   if (state.loading === true)
  //     setTimeout(() => {
  //       setState((prev) => {
  //         return {
  //           ...prev,
  //           loading: false,
  //         };
  //       });
  //     }, 2000);
  // }, [state.loading]);

  return (
    <Card
      loading={state.loading}
      title={title}
      headStyle={{
        borderBottom: 0,
        // fontFamily: 'Public Sans',
        // fontStyle: 'normal',
      }}
      bodyStyle={{
        paddingTop: 0,
        alignItems: 'flex-start',
      }}
      bordered={false}
    >
      <div style={{ ...styles.container }}>
        <BaseItemInput
          onClick={(e) => {
            // const { value } = e;
            const value = String(e?.value || '').trim();
            setState((prev) => {
              return {
                ...prev,
                value: '',
                loading: true,
              };
            });

            addItem({ value, setChildState: setState });
          }}
        />
        <div style={{ ...styles.body }}>
          {categories?.map((item, index) => {
            return (
              <ItemCategory
                data={item}
                index={index}
                selectedId={selectedId}
                OnCellClick={OnCellClick}
                setChildState={setState}
                updateItem={updateItem}
                deleteItem={deleteItem}
              />
            );
          })}
        </div>
      </div>
    </Card>
  );
};

export default ExerciseCategory;
